import { createElement, Fragment } from 'react';

const ITALIC_PATTERN = /\*([^*]+)\*/g;

// Editors wrap a word in asterisks in Contentful (e.g. "the *new* season") to italicise it.
// Plain strings without asterisks are returned untouched, so existing content is unaffected.
export default function renderInlineItalic(text) {
  if (typeof text !== 'string' || !text.includes('*')) return text;

  const nodes = [];
  let lastIndex = 0;
  let key = 0;
  let match;

  ITALIC_PATTERN.lastIndex = 0;
  while ((match = ITALIC_PATTERN.exec(text)) !== null) {
    if (match.index > lastIndex) nodes.push(text.slice(lastIndex, match.index));
    nodes.push(createElement('i', { key: key++ }, match[1]));
    lastIndex = match.index + match[0].length;
  }

  if (lastIndex < text.length) nodes.push(text.slice(lastIndex));

  return createElement(Fragment, null, ...nodes);
}
